import React, { Component } from 'react';
import { Eula as EulaContent } from 'sub_components/Common/Eula';
import { UserApi } from 'services/user';

class Eula extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: '//www.dcblox.com/terms-of-use',
			version: null,
			lastUpdated: null,
		};
	}
	componentDidMount() {
		this.getEulaLatestVersion();
	}
	getEulaLatestVersion = () => {
		UserApi.getEulaVersion()
			.then(response => {
				const validResponse = response.status === 200 && response.data;
				if (validResponse) {
					this.setState({ version: response.data?.version, lastUpdated: response.data?.updated });
				}
			})
			.catch(() => {});
	};

	formatDate = date => {
		const formattedDate = date.split('.');
		return formattedDate[0];
	};

	render() {
		const { site } = this.props;
		const { version, lastUpdated } = this.state;
		return (
			<div className='eula-container'>
				<div className='header'>
					<div className='text footer70'>END USER LICENSE AGREEMENT</div>
					<div className='latest-update-wrapper'>
						<div className='last-update footer31'>
							LAST UPDATE:
							<div className='date footer40'>{lastUpdated && this.formatDate(lastUpdated)}</div>
						</div>
					</div>
					{/* <div className='notifications'>
						<div className='amount footer11'>6</div>
						<img src={notificationDiamond} />
					</div> */}
				</div>
				<div className={`content ${site?.module}`}>
					<EulaContent site={site} version={version} />
				</div>
				<div className='footer-section '>
					<div className='terms-section'>
						<div className='text footer50'>TERMS/POLICIES</div>
						{/* <div className='notifications'>
							<div className='amount footer11'>1</div>
							<img src={notificationDiamond} />
						</div> */}
					</div>

					<div className='eula-section'>
						<div className='text footer50'>EULA</div>
						{/* <div className='notifications'>
							<div className='amount footer11'>1</div>
							<img src={notificationDiamond} />
						</div> */}
					</div>
					<div className='release-notes-section'>
						<div className='text footer50'>RELEASE NOTES</div>
						{/* <div className='notifications'>
							<div className='amount footer11'>1</div>
							<img src={notificationDiamond} />
						</div> */}
					</div>
				</div>
			</div>
		);
	}
}
export default Eula;
